import { getTenant } from "../shared/tenant.util";

const BASE_API_URL = getTenant();

// Campaign and FormServices API paths
// Base URLs come from GetHostInfo API (stored in buyerInfo)
// For local dev, proxy.conf.json routes these to correct ports
const CAMPAIGN_API = `api/Campaign/`;
const CAMPAIGN_API_V1 = `api/v1/Campaign/`;
const BULK_USER_API = `api/BulkLoadUser/`;
// SM-3347: FormSet APIs now route through OBM-Core PaaS instead of direct Form Services calls
const FORM_SET_API = `${BASE_API_URL}/Buyer/FormSet/`;
const SUPPLIER_USER_API = `${BASE_API_URL}/Supplier/`;

export const ApiUrl = {
  SUPPLIER_GET_SETTINGS: `${SUPPLIER_USER_API}FWClient/GetSupplierSetting/`,
  GET_SEARCH_DATA_URL: `${BASE_API_URL}/Buyer/Supplier/SearchSupplier?`,
  GET_COUNTRY_DETAILS_URL: `${BASE_API_URL}/Buyer/Supplier/GetCountries`,
  GET_ORGPROFILE_DETAILS_URL: `${BASE_API_URL}/Buyer/FWClient/GetSupplierProfile?`,
  GET_GROUP_BY_SUPPLIER_UUID: `${BASE_API_URL}/Buyer/Group/GetGroupBySupplierUUID?UUID=`,
  GET_HOME_PAGE_CONTENT_URL: `${BASE_API_URL}/Buyer/Dashboard/GetDashboard`,
  SUBMIT_INVITE_SUPPLIER: `${CAMPAIGN_API}SaveSingleorGroupSupplierInvite`,
  GET_All_GROUPS_METHOD_URL: `${BASE_API_URL}/Buyer/Group/GetAllGroups`,
  CREATE_GROUP_URL: `${BASE_API_URL}/Buyer/Group/CreateGroup`,
  CLONE_GROUP_URL: `${BASE_API_URL}/Buyer/Group/CloneGroup`,
  EDIT_GROUP_URL: `${BASE_API_URL}/Buyer/Group/EditGroup`,
  REMOVE_SUPPLIER_URL: `${BASE_API_URL}/Buyer/Group/RemoveSupplierFromGroup`,
  DELETE_GROUP_URL: `${BASE_API_URL}/Buyer/Group/DeleteGroup/`,
  ADD_SUPPLIERs_TO_GROUP_URL: `${BASE_API_URL}/Buyer/Group/AddSuppliersToGroup`,
  GET_GROUP_DROP_DOWM_METHOD_URL: `${BASE_API_URL}/Buyer/Group/GetAllGroups`,
  GET_GROUP_BY_GROUPID_URL: `${BASE_API_URL}/Buyer/Group/GetGroup/`,
  // SM-3254: Fixed URL to use path parameter instead of query parameter
  // Controller route is [Route("GetOrgUsersByExostarID/{exostarId}")]
  GET_USER_DETAILS: `${BASE_API_URL}/Buyer/FWClient/GetOrgUsersByExostarID/`,
  GET_STATE_BASED_ON_COUNTRY: `${BASE_API_URL}/Buyer/Supplier/GetStatesListByCId/`,
  GET_CAMPAIGN_LIST_URL: `${CAMPAIGN_API}list`,
  GET_BULK_LOAD_LIST_URL: `${BULK_USER_API}listBulkUsers`,
  CSV_UPLOAD_IN_CAMPAIGN_URL: `${CAMPAIGN_API_V1}create`,
  USER_CSV_UPLOAD_BULK: `${BULK_USER_API}create`,
  GET_CAMPAIGNDETAILS_DATA_URL: `${CAMPAIGN_API_V1}get?`,
  GET_CAMPAIGN_BULK_LOAD_DETAILS_DATA_URL: `${BULK_USER_API}getEmailAddresses?`,
  GET_MATCHING_SUPPLIERS_DATA_URL: `${CAMPAIGN_API}getMatchingSuppliers?`,
  SET_MATCHING_SUPPLIERS_URL: `${CAMPAIGN_API}saveValidation`,
  GET_MATCHING_USER_BY_EMAIL_URL: `${BULK_USER_API}getMatchingUserDetailsByEmail?`,
  GET_CAMPAIGN_STATUS_URL: `${CAMPAIGN_API_V1}getStats?`,
  GET_INFO_URL: `${BASE_API_URL}/Shared/Common/GetHostInfo`,
  GET_BUYER_SUBSCRIPTIONS_URL: `${BASE_API_URL}/Buyer/Supplier/GetBuyerSubscriptions`,
  GET_USER_SUBSCRIPTIONS_URL: `${BASE_API_URL}/Buyer/FWClient/GetMAGAPIUserSubscriptions`,
  GET_INVITATION_STATUS_FOR_CSV_DOWNLOAD: `${BULK_USER_API}getInvitationStatusForCSVDownload`,
  GET_BUYER_FORMS: `${BASE_API_URL}/Buyer/Supplier/GetBuyerForms`,
  GET_APPROVERS: `${BASE_API_URL}/Buyer/Supplier/GetApprovers`,
  POST_SAVE_ACTION_PREFERENCE: `${CAMPAIGN_API}saveActionPreference`,
  BULK_USER_UPDATE_ACTION_PREFERENCE: `${BULK_USER_API}updateActionPreference`,
  DOWNLOAD_SUCCESS_ISSUES: `${CAMPAIGN_API_V1}getInvitationStatus`,
  GET_INVITEED_SUPPLIERS: `${CAMPAIGN_API}getFilteredInvitedSuppliers?`,
  GET_FAILED_ENROLLMENTS: `api/v1/Enrollment/GetFailedEnrollments`,
  GET_INVITED_SUPPLIER_STATUS: `${CAMPAIGN_API}getInvitedSupplierStatus?`,
  GET_ORGANIZATION_SUBSCRIPTIONS: `${BASE_API_URL}/Buyer/FWClient/GetOrgSubscriptions/`,
  GET_ENROLLMENT_STATUS: `${CAMPAIGN_API_V1}getEnrollmentStatusV1`,
  GET_CURRENT_FORM_STATUS: `${BASE_API_URL}/Buyer/FwClient/GetLatestFormStatusV1?formRefIdpayload=`,
  DELETE_CAMPAIGN: `${CAMPAIGN_API}DeleteCampaign`,
  BULK_DELETE_CAMPAIGN: `${CAMPAIGN_API}BulkDeleteCampaigns`,
  GET_DASHBOARD_DETAILS: `${BASE_API_URL}/Buyer/Dashboard/GetDashboardReportData/`,
  GET_BUYER_FEATURE_LIST: `${BASE_API_URL}/Shared/Common/GetBuyerFeatureList`,
  GET_USER_LOGIN_DETAILS: `${BASE_API_URL}/Shared/Common/GetUserloginDetails`,
  GET_CROWDSTRIKE_SCAN_DETAILS: `${BASE_API_URL}/Buyer/FWClient/ScanAttachment`,
  GET_FORM_REQUESTS: `${BASE_API_URL}/Support/FWClient/GetFormRequests`,
  DELETE_FORM_REQUESTS: `${BASE_API_URL}/Support/FWClient/DeleteFormRequests`,
  BULK_USER_UPLOAD_DELETE_CAMPAIGN: `${BULK_USER_API}BulkDeleteUserCampaigns`,
  BULK_USER_DELETE_CAMPAIGN: `${BULK_USER_API}DeleteUserCampaign`,
  GET_UPDATE_BULK_USER_CURATION_STATUS: `${BULK_USER_API}UpdateBulkUserCurationStatus`,
  GET_BULK_LOAD_STATUS: `${BULK_USER_API}getStatus?bulkUsercampaignId=`,
  UPLOAD_BULK_LOAD_CAMPAIGN_STATUS: `${BULK_USER_API}updateBulkUserCampaignStatus?bulkUsercampaignId=`,
  GET_ALL_USER_ENROLLMENTS: `${BULK_USER_API}getFilteredInvitedUsers?`,
  GET_FAILED_USER_ENROLLMENTS: `${BULK_USER_API}GetFailedEnrollmentsForBulkUser`,
  GET_ALL_EMAIL_TEMPLATES: `${BASE_API_URL}/Buyer/EmailTemplate/GetAllTemplates`,
  GET_DASHBOARD_CHART_DETAILS: `${BASE_API_URL}/Buyer/Graph/GetInsightByFacet?id=`,
  GET_INSIGHT_BY_FACET: `${BASE_API_URL}/Buyer/Graph/GetInsightData?`,
  GET_COMPLAINCE_RISK: `${BASE_API_URL}/Buyer/FWClient/GetSupplierOrgDetails`,
  GET_DROPDOWN_OPTIONS: `${BASE_API_URL}/Buyer/FWClient/GetDropdownsSetting?dropdownValue=`,
  SAVE_SUPPLIER_ACTIONS: `${BASE_API_URL}/Buyer/FWClient/SaveSupplierActions`,
  ADD_EMAIL_OR_COMMENT: `${BASE_API_URL}/Buyer/FWClient/SaveSupplierActionsAndNotify`,
  GET_PREVIOUS_ACTIONS: `${BASE_API_URL}/Buyer/FWClient/GetPreviousActionsSuppliers?SupplierUUID=`,
  UPDATE_COMMENTS: `${BASE_API_URL}/Buyer/FWClient/UpdateSupplierActions`,
  GET_ALL_USER_READ: `${BASE_API_URL}/Buyer/User/GetAllUser_Read/`,
  GET_CURRENT_USER_DETAILS: `${BASE_API_URL}/Buyer/User/GetCurrentUserDetails`,
  GET_ALL_ROLEDEFINITIONS_READ: `${BASE_API_URL}/Buyer/User/RoleDefinitions_Read`,
  GET_EMAIL_TEMPLATE_DETAILS: `${BASE_API_URL}/Buyer/EmailTemplate/EditTemplate`,
  UPDATE_EMAIL_TEMPLATE: `${BASE_API_URL}/Buyer/EmailTemplate/UpdateTemplate`,
  GET_GENERAL_SETTINGS: `${BASE_API_URL}/Buyer/Setting/GetGeneralSettings`,
  GET_SETTINGS_READ: `${BASE_API_URL}/Buyer/Setting/GetSettings_Read`,
  GET_TWO_FACTOR_AUTH: `${BASE_API_URL}/Buyer/Setting/GetTwofactorConfiguration`,
  GET_HELP_LINKS: `${BASE_API_URL}/Buyer/Setting/GetHelpLinks`,
  GET_BANNERS: `${BASE_API_URL}/Buyer/Banner/GetAnnouncementBanners_Read`,
  ADD_BANNERS: `${BASE_API_URL}/Buyer/Banner/AnnouncementBanner_Create`,
  DELETE_BANNER: `${BASE_API_URL}/Buyer/Banner/AnnouncementBanner_Destroy`,
  UPDATE_BANNER: `${BASE_API_URL}/Buyer/Banner/AnnouncementBanner_Update`,
  LOGO_SAVE_SETTINGS: `${BASE_API_URL}/Buyer/Setting/CustomDropZone_Save`,
  GET_USER_ROLE_INFO: `${BASE_API_URL}/Buyer/User/GetUserRoleInformation/`,
  UPDATE_BUYER_USER_ROLE: `${BASE_API_URL}/Buyer/User/UpdateUserRole?`,
  GET_ROLE_PERMISSION: `${BASE_API_URL}/Buyer/User/GetRolePermissions?roleUniqueId=`,
  GET_ORGANIZATION_BY_NAME: `${BASE_API_URL}/Buyer/Organization/GetOrganizationByName/`,
  GET_PERMISSION_BY_AUDIENCE: `${BASE_API_URL}/Buyer/User/GetPermissionsByAudience/`,
  UPDATE_ROLE_PERMISSION: `${BASE_API_URL}/Buyer/User/UpdateRolePermission?Operation=`,
  ADD_ROLE_PERMISSION: `${BASE_API_URL}/Buyer/User/AddRolePermission`,
  SAVE_LOGO: `${BASE_API_URL}/Buyer/Setting/AddLogo`,
  UPDATE_TWO_FACTOR_AUTH: `Buyer/Setting/UpdateTwoFactor?AssuranceLevel`,
  ADD_SETTING_UP_LINKS: `${BASE_API_URL}/Buyer/Setting/AddLinks`,
  GET_NOTIFICATION_SETTINGS: `${BASE_API_URL}/Buyer/EventDefinition/GetEventDefinition_Read`,
  GET_ONBOARDING_SETTINGS: `${BASE_API_URL}/Buyer/Setting/GetOnboardingSettings`,
  GET_FORM_CATEGORY: `${BASE_API_URL}/Buyer/Setting/GetFormCategory`,
  GET_FORM_ATTRIBUTE: `${BASE_API_URL}/Buyer/Setting/GetFormTagByCId`,
  ATTRIBUTE_SETTINGS_OPERATION: `${BASE_API_URL}/Buyer/Setting/TagingOperation`,
  GET_SUPPLIER_LIST_FOR_ATTRIBUTE_SETTINGS: `${BASE_API_URL}/Buyer/Setting/GetTaggingSupplierList`,
  GET_USER_PROFILE: `${BASE_API_URL}/Shared/Common/getUserProfileDetails/`,
  GET_ORGANIZATION_PROFILE: `${BASE_API_URL}/Shared/Common/GetOrgDetailsByUniqueId/`,
  UPDATE_ONBOARDING_SETTINGS: `${BASE_API_URL}/Buyer/Setting/UpdateOnboardingStatus`,
  UPDATE_ATTRIBUTE_SETTINGS: `${BASE_API_URL}/Buyer/Setting/AssociateTagsToSupplier`,
  GET_ORGANIZATION_FORM_REQUEST: `${BASE_API_URL}/Buyer/FormRequest/OrganizationFormRequest_Read`,
  GET_COMPLETED_FORM_REQUEST_COUNT: `${BASE_API_URL}/Buyer/FormRequest/CompletedFormRequestCount_Read`,
  GET_BUYER_FORM_REQUEST_DROPDOWNS: `${BASE_API_URL}/Buyer/Default/FormRequest`,
  GET_ORG_NAME_ORGNUM_UUID: `${BASE_API_URL}/Buyer/Supplier/GetOrgByNameORUNUMORUUID?searchText=`,
  GET_BUYER_APPROVER_DATA: `${BASE_API_URL}/Buyer/Approver/ApproverFormRequestRead`,
  CANCEL_FORM_REQUEST: `${BASE_API_URL}/Buyer/FormRequest/CancelFormRequest?`,
  GET_REASSIGN_SUPPLIER: `${BASE_API_URL}/Buyer/FormRequest/ReassignSupplier?formReqRefId=`,
  REASSIGN_SUPPLIER: `${BASE_API_URL}/Buyer/FormRequest/ReassignSupplier?`,
  GET_FORM_DROPDOWN_OPTIONS: `${BASE_API_URL}/Buyer/Approver/ApproverRequest`,
  GET_ALL_APPROVER_USERS: `${BASE_API_URL}/Buyer/Approver/GetAllApproverUsers`,
  REASSIGN_APPROVER: `${BASE_API_URL}/Buyer/Approver/ReassignApprover`,
  GET_APPROVER_SUMMARY: `${BASE_API_URL}/Shared/Form/ApproverSummary`,
  SUBMIT_APPROVAL_DECISION: `${BASE_API_URL}/Shared/Form/ApproverDecisionSubmit`,
  MARK_AS_COMPLETE: `${BASE_API_URL}/Shared/Form/ByPasssApprovalWorkflow`,
  ORGANIZATION_SUPPLIER_PROFILE: `${BASE_API_URL}/Buyer/Organization?id=`,
  ORG_SUPPLIER_DASHEXPGRIDBIND: `${BASE_API_URL}/Buyer/Organization/DashboardExpGridBind?supplierUniqId=`,
  REASSIGN_SUPPLIER_BY_REJECTED_WORKFLOW: `${BASE_API_URL}/Shared/Form/ReassignSupplierByRejectedWorkflow`,
  GET_SUPPLIER_ADMIN_USERS: `${BASE_API_URL}/Buyer/Approver/GetSupplierAdminUsers`,
  BASEFORM_AUTOCOMPLELETE_READ: `${BASE_API_URL}/Buyer/BaseForm/BaseForm_AutoComplete_Read?`,
  GET_FORM_DETIALS: `${BASE_API_URL}/Buyer/Form?id=`,
  GET_FORMREQUEST_HISTORY_READ: `${BASE_API_URL}/Buyer/Form/FormRequestHistory_Read?id=`,
  FORM_DELEGATION_READ: `${BASE_API_URL}/Shared/Form/FormDelegation_Read?orgFormId=`,
  FORM_REQUEST_WORKFLOW_TIMELINE: `${BASE_API_URL}/Buyer/Form/FormRequestWorkflowTimeline?id=`,
  GET_ASSIGN_APPROVERS: `${BASE_API_URL}/Buyer/FormRequest/AssignApprover?`,
  GET_SYSTEM_FORM_READ: `${BASE_API_URL}/Buyer/BaseForm/SystemForm_Read`,
  UPDATE_FORM: `${BASE_API_URL}/Buyer/BaseForm/UpdateForm?`,
  CLONE_FORM: `${BASE_API_URL}/Buyer/FormRequest/CloneFormRequest`,
  ASSIGN_APPROVERS: `${BASE_API_URL}/Buyer/FormRequest/AssignApproverViaFormsDetail?`,
  USER_DROPDOWN_READ: `${BASE_API_URL}/Buyer/Organization/User_DropDown_Read?unum=`,
  GET_ALL_SUPPLIERS_READ: `${BASE_API_URL}/Buyer/Supplier/GetAllSuppliers_Read?selectedSupppliers=`,
  APPROVER_DROPDOWN_READ: `${BASE_API_URL}/Buyer/Organization/Approver_DropDown_Read?unum=`,
  ADD_SYSTEM_FORM: `${BASE_API_URL}/Buyer/FormWizard/AddSystemFormWithTemplate`,
  ASSIGN_FORM_REQUEST: `${BASE_API_URL}/Buyer/FormRequest/AssignFormRequest`,
  GET_SUPPLIER_BY_TAG_NAME: `${BASE_API_URL}/Buyer/Supplier/GetSupplierByTagName?`,
  BASEFORM_DROPDOWN_URL: `${BASE_API_URL}/Buyer/FormWizard/BaseForm_Dropdown_AutoComplete_Read`,
  EDIT_FORM_URL: `${BASE_API_URL}/Buyer/FormWizard/EditSystemForm`,
  GET_BASE_FORM_DTLS_URL: `${BASE_API_URL}/Buyer/FormWizard/GetBaseFormDetail`,
  CAN_ACTIVE_UPGRADE: `${BASE_API_URL}/Buyer/FormUpgrade/CheckActiveUpgrades`,
  GET_SOURCE_FORM_URl: `${BASE_API_URL}/Buyer/FormUpgrade/GetSourceForm`,
  GET_DESTINATION_FORM: `${BASE_API_URL}/Buyer/FormUpgrade/GetDestinationForms`,
  GET_QUESTION_MAPPING_URL: `${BASE_API_URL}/Buyer/FormUpgrade/GetQuestionMappingData`,
  GET_SOURCE_FORM_QUESTION_URL: `${BASE_API_URL}/Buyer/FormUpgrade/GetSourceFormQuestions`,
  GET_DESTINATION_FORM_QUESTION_URL: `${BASE_API_URL}/Buyer/FormUpgrade/GetDestinationFormQuestions`,
  PROCESS_FORM_UPGRADE_URL: `${BASE_API_URL}/Buyer/FormUpgrade/ProcessFormUpgradation`,
  DELETE_UPGRADE_URL: `${BASE_API_URL}/Buyer/FormUpgrade/DeleteUpgrade`,
  FORM_WIZARD_VIEWINPUT: `${BASE_API_URL}/Buyer/FormWizard/ViewInput?`,
  EDIT_NEW_SYSTEM_FORM: `${BASE_API_URL}/Buyer/FormWizard/EditNewSystemForm?`,
  UPGRADE_FORM: `${BASE_API_URL}/Buyer/FormUpgrade/UpgradeForm`,
  GET_LOGO: `${BASE_API_URL}/Shared/Common/GetLogo`,
  GET_AUTH_TOKEN: `${BASE_API_URL}/api/Token`,
  GET_EXTERNAL_SOURCE_NAMES: `${BASE_API_URL}/Buyer/FWClient/GetExternalSourceNames`,
  SKIP_FAILED_CAMPAIGNS: `${CAMPAIGN_API_V1}skipCampaignSuppliers`,
  GET_FAILED_CAMPAIGNDETAILS_DATA_URL: `${CAMPAIGN_API_V1}getCampaignSuppliersAuditInfo?`,
  GET_INVITED_SUPPLIERS: `${CAMPAIGN_API}getFilteredInvitedSuppliers?`,
  GET_SUPPLIER_ORGANIZATION_FORM_REQUEST: `${SUPPLIER_USER_API}FormRequest/OrganizationFormRequest`,
  SUPPLIER_REASSIGN: `${SUPPLIER_USER_API}FormRequest/ReassignSupplier`,
  ASSIGN_SUPPLIER_APPROVERS: `${SUPPLIER_USER_API}FormRequest/AssignSupplierApproversRequest`,
  SUPPLIER_FORM_RENEW_REQUEST: `${SUPPLIER_USER_API}FormRequest/RenewFormRequest`,
  SUPPLIER_GET_ORG: `${SUPPLIER_USER_API}Organization`,
  GET_USER_ROLE_INFORMATION: `${SUPPLIER_USER_API}User/GetUserRoleInformation/`,
  UPDATE_USER_ROLE: `${SUPPLIER_USER_API}User/UpdateUserRole?`,
  SUPPLIER_GET_ORG_USER_LIST: `${SUPPLIER_USER_API}Organization/GetOrgUsersByUniqueId/`,
  ASSIGN_SUPPLIER_APPROVER: `${SUPPLIER_USER_API}FormRequest/AssignSupplierApproversRequest`,
  SHARED_APPROVER_SUMMARY: `${BASE_API_URL}/Shared/Form/ApproverSummary`,
  FORM_ASSIGNED_APPROVER_USER: `${SUPPLIER_USER_API}FormRequest/FormAssignedSupplierApprover`,
  GET_SETTING_VALUE: `${BASE_API_URL}/Buyer/FWClient/GetSettingValue?settingKey=`,
  // SM-3426: Supplier-area GetSettingValue (Supplier/FWClientController) — same {success, data}
  // shape as Buyer. Supplier (SEM/LMC) logins must use this; the Buyer endpoint returns 403.
  SUPPLIER_GET_SETTING_VALUE: `${SUPPLIER_USER_API}FWClient/GetSettingValue?settingKey=`,
  GET_SUPPLIER_FORM_REQUEST_DETAILS: `${SUPPLIER_USER_API}Form/GetFormRequestDetails?id=`,
  SUPPLIER_FORM_INPUT_TRACK_READ: `${SUPPLIER_USER_API}Form/FormInputTrack_Read?orgFormId=`,
  SUPPLIER_FORM_DELEGATION_READ: `${BASE_API_URL}/Shared/Form/FormDelegation_Read?orgFormId=`,
  SUPPLIER_EDIT_FORM: `${BASE_API_URL}/Shared/Form/EditForms`,
  DOWNLOAD_REVISION: `${BASE_API_URL}/Shared/Form/DownloadForm`,
  DOWNLOAD_OFFLINE_FORM: `${BASE_API_URL}/Shared/Form/DownloadOfflineForm`,
  SUPPLIER_COMMUNICATIONS: `${BASE_API_URL}/Shared/Common/Discussions_Read?rowCount=`,
  ADD_ANSWER_TO_QUESTION: `${BASE_API_URL}/Shared/Common/AddAnswer`,
  SUBMIT_QUESTION: `${BASE_API_URL}/Shared/Common/AddQuestion`,
  SUPPLIER_CREATE_PROCESS_TASK_FOR_UPGRADE: `${SUPPLIER_USER_API}UpgradeForm/CreateProcessTask`,
  SUPPLIER_AUTO_UPGRADE: `${SUPPLIER_USER_API}UpgradeForm/AutoUpgrade`,
  SUPPLIER_CANCEL_PROCESS_TASK: `${SUPPLIER_USER_API}UpgradeForm/CancelProcessTask`,
  GET_SAS_TOKEN: `${BASE_API_URL}/Shared/Form/get-sas-token`,
  GET_MALWARE_SCAN_STATUS: `${BASE_API_URL}/Shared/Form/GetMalwareScanFileStatus/`,
  PROCESS_OFFLINE_INPUT_CSV: `${BASE_API_URL}/Shared/Form/ProcessOfflineInputCSV`,
  PROCESS_OFFLINE_INPUT_PDF: `${BASE_API_URL}/Shared/Form/ProcessOfflineInputPdf`,
  CSV_UPLOAD_IN_CAMPAIGN_URL_V1: `${CAMPAIGN_API_V1}create`,
  CAMPAIGN_RETRY: `${CAMPAIGN_API}retryCampaignAsync`,
  FETCH_SINGLE_INVITE_DATA: `${CAMPAIGN_API}retrySingleAsync?id=`,
  GET_DATA_CORRECTIONS_TAB_DATA: `${CAMPAIGN_API}ValidateCampaignData?`,
  GET_DATA_CORRECTIONS_COLUMN_MAPPING_DATA: `${CAMPAIGN_API}getColumnMapping`,
  REVALIDATE_CAMPAIGN_DATA: `${CAMPAIGN_API}UpdateCampaignDataValidation`,
  // SM-3347: FormSet APIs now route through OBM-Core PaaS instead of direct Form Services calls
  CREAT_NEW_FORMSET: `${FORM_SET_API}SaveFormSets`,
  GET_ALL_FORMSETS: `${FORM_SET_API}GetAllFormSets`,
  CLONE_FORMSET: `${FORM_SET_API}CloneFormSets`,
  DELETE_FORMSET: `${FORM_SET_API}DeleteFormSets`,
  EDIT_FORMSET: `${FORM_SET_API}EditFormSets`,
  GET_ALL_DELETED_FORMSETLIST: `${FORM_SET_API}GetAllDeletedFormSets`,
  // SM-3426: The Buyer banner endpoints are gated to UserRoleContext.Buyer in obm-core.
  GET_ACTIVE_BANNERS: `${BASE_API_URL}/Buyer/Banner/GetActiveMaintenanceBanners`,
  GET_ACTIVE_SITE_BANNERS: `${BASE_API_URL}/Buyer/Banner/GetActiveSiteBanners`,
  // SM-3426: Supplier-area banner endpoints (Supplier/BannerController in obm-core) expose the
  // same global banner data to Supplier (SEM/LMC) logins, replicating the legacy
  // Supplier/Default/ActiveBanner behavior (Site + Maintenance banners) for the Angular UI.
  SUPPLIER_GET_ACTIVE_BANNERS: `${SUPPLIER_USER_API}Banner/GetActiveMaintenanceBanners`,
  SUPPLIER_GET_ACTIVE_SITE_BANNERS: `${SUPPLIER_USER_API}Banner/GetActiveSiteBanners`,
  IS_TERMS_AND_CONDITION_ACCEPTED: `${BASE_API_URL}/Shared/Common/IsTermsAndConditionAccepted`,
  ACCEPT_TERMS_AND_CONDITION: `${BASE_API_URL}/Shared/Common/AcceptTermsAndCondition`,
  GET_CAMPAIGN_TEMPLATE_URL: `${BASE_API_URL}/Buyer/EmailTemplate/GetCampaignTemplateUrl`
};
